<template>
  <el-dropdown trigger="click" @command="handleCommand">
    <span class="el-dropdown-link">
      <div :class="[ 'flag-dropdown', hasBlackBorder ? 'has-black-border' : '' ]">
        <img :src="getSrc($i18n.locale)" width="22">
        <i class="el-icon-caret-bottom"></i>
      </div>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="lang in $i18n.availableLocales" :key="lang" :value="lang" :command="lang">
        <img :src="getSrc(lang)" width="16">
        {{ languageString(lang) }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>

import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import Cookies from 'js-cookie'

const COUNTRIES = {
  'ru': 'Русский',
  'az': 'Azərbaycan'
}

export default {
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  props: {
    hasBlackBorder: false
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false
    }
  },
  methods: {
    handleCommand(command) {
      this.$i18n.locale = command
      document.title = this.$t('Customer portal')
      Cookies.set('language', command, { expires: 30, path: window.location.pathname })
    },
    getSrc(country = 'xx') {
      if (country === 'en') {
        country = 'gb'
      }
      return `https://hatscripts.github.io/circle-flags/flags/${country}.svg`
    },
    languageString(lang) {
      return COUNTRIES[lang]
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dropdown-menu__item img {
    margin-right: 4px;
  }
.flag-dropdown {
  display: flex;
  align-items: center;
  color: white;
  padding: 8px;

  & > img {
    margin-right: 4px;
    border: 1px solid white;
    border-radius: 50%;
  }
  &:hover {
    cursor: pointer;
    background-color: hsla(0,0%,100%,.2);
    border-radius: .1875rem;
  }

  &.has-black-border {
    color: #606266;
    &:hover {
      background-color: rgba(222, 222, 222, 0.8);
      color: #f96332;
    }
    & > img {
      border: 1px solid #606266;
    }
  }
}
</style>>
